<template>
  <FormContainer>
    <template #title>Coordonnées du salarié(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_132"
          :model-value="salariéEnCours?.adresse?.voie"
          @update:model-value="(value) => updateModule('adresse.voie', activeSalariéIndex!, value)"
          :label="LABEL_NUMERO_VOIE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_VOIE"
          :required="metaSalarieEnCours?.adresse?.voie?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.adresse?.voie?.$messageErreurDirty!"
          :maxlength="38"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_133"
          :model-value="salariéEnCours?.adresse?.complement"
          @update:model-value="(value) => updateModule('adresse.complement', activeSalariéIndex!, value)"
          label="Complément d'adresse"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_COMPLEMENT"
          :required="metaSalarieEnCours?.adresse?.complement?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.adresse?.complement?.$messageErreurDirty!"
          :maxlength="38"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_134"
          :model-value="salariéEnCours?.adresse?.codePostal"
          @update:model-value="(value) => updateModule('adresse.codePostal', activeSalariéIndex!, value)"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_CP"
          :required="metaSalarieEnCours?.adresse?.codePostal?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.adresse?.codePostal?.$messageErreurDirty!"
          :maxlength="5"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_135"
          :model-value="salariéEnCours?.adresse?.commune"
          @update:model-value="(value) => updateModule('adresse.commune', activeSalariéIndex!, value)"
          label="Ville"
          class="col-8 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_VILLE"
          :required="metaSalarieEnCours?.adresse?.commune?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.adresse?.commune?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInputTelephone
          id="field_136"
          :model-value="salariéEnCours?.telephone"
          @update:model-value="(value) => updateModule('telephone', activeSalariéIndex!, value)"
          label="Téléphone"
          :required="metaSalarieEnCours?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.telephone?.$messageErreurDirty!"
          class="col-6 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          :maxlength="10"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_137"
          :model-value="salariéEnCours?.email"
          @update:model-value="(value) => updateModule('email', activeSalariéIndex!, value)"
          label="Email"
          :required="metaSalarieEnCours?.email?.$status === PropertyStatus.Required"
          :alertLabel="metaSalarieEnCours?.email?.$messageErreurDirty!"
          hint="64 caractères maximum"
          class="col-10 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          :maxlength="64"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { AF_SALARIES_ACTIONS } from '@/features/interface/demande/af/steps/salarie/useSalarieActions'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    FormContainer,
    LABEL_NUMERO_VOIE,
    PLACEHOLDER_ADR_VOIE,
    PLACEHOLDER_ADR_VILLE,
    PLACEHOLDER_ADR_COMPLEMENT,
    PLACEHOLDER_ADR_CP,
    PLACEHOLDER_EMAIL,
    PLACEHOLDER_TEL,
  } from '@/features/interface/demande/shared'
  import type { SalarieDTO } from '@/features/api/extranet/dto/Demande/AF'

  const store = useDemandeAFStore()
  const { setupArrayUpdaterWithKey } = store

  const { readonly } = storeToRefs(store)
  const { activeSalariéIndex, salariéEnCours, metaSalarieEnCours } = inject(AF_SALARIES_ACTIONS)!

  const updateModule = setupArrayUpdaterWithKey<SalarieDTO>('salaries')
</script>
